import html2canvas from 'html2canvas'
import Axios from 'axios'
import bugsnag from '../plugins/bugsnag'

const axios = Axios.create({ withCredentials: false, timeout: 1000 * 180 })
const BASE_URL = window.location.hostname.includes('localhost')
  ? 'https://integ.lili.co/lili/api/'
  : '/lili/api/'

export const takeSnapshot = (isRawBlob = false) =>
  new Promise((resolve, reject) => {
    html2canvas(document.body).then((canvas) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('SnapShot failed'))
        }
        if (isRawBlob) {
          resolve(blob)
          return
        }
        const fd = new FormData()
        fd.append('image', blob, 'T&C Confirm')
        resolve(fd)
      })
    })
  })

export const uploadGenericFile = async (
  accessToken,
  customerId,
  fileUsageType,
  imageName,
  dataFileName
) => {
  const formData = new FormData()
  try {
    const imageBlob = await takeSnapshot(true)

    const dataBlob = new Blob([
      JSON.stringify({
        fileUsageType: fileUsageType,
        fileName: dataFileName,
      }),
    ])

    formData.append('image', imageBlob, imageName)
    formData.append('data', dataBlob)

    await axios({
      method: 'post',
      url: `v1/user/${customerId}/uploadImageFile`,
      baseURL: BASE_URL,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
    })
  } catch (e) {
    bugsnag.notify('Error in uploading generic file', e)
  }
}

export const uploadTermsAndConditions = async (
  customerId,
  accessToken,
  event
) => {
  try {
    const formDataInstance = await takeSnapshot()

    const consentValue = await axios({
      method: 'get',
      url: `v4/secureonboarding/${customerId}/termsAndCondition?event=${event}`,
      baseURL: BASE_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })

    formDataInstance.append(
      'consents',
      new Blob([JSON.stringify(consentValue.data.termsAndConditions)], {
        type: 'application/json',
      })
    )
    await axios({
      method: 'post',
      url: `v1/user/${customerId}/terms_and_conditions/consent`,
      baseURL: BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
      data: formDataInstance,
    })
    return true
  } catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/services/SnapShotService.js